import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useRequestDropDown, useBankCode, useGetOptionAndPaymentPdf } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, { useEffect } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import redright from 'assets/images/redright.svg';
// import { useNavigate } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
// import { formatCardNumber2 } from 'utils/formate/cardNumber';
// import Visibility from 'assets/images/eye-open.svg';
// import VisibilityOff from 'assets/images/eye-off.svg';
// const { useBreakpoint } = Grid;
// import styled from 'styled-components';

interface commonListProps {
  label: string;
  labelTc: string;
  value: string;
  code: string;
}
export const PolicyOptionsCard = (props: {
  dividendOptionsList: commonListProps[];
  paymentOptionsList: commonListProps[];
  paymentMethodList: commonListProps[];
  chequeList: commonListProps[];
  annPaymentMethodList: commonListProps[];
  payPMName: string;
  divPMName: string;
  diviName: string;
  payName: string;
}) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  const { token } = useKeycloakReady();
  // const navigate = useNavigate();
  // const [bankdefult, setbankdefult] = useState('');
  // const [showCardMask, setShowCardMask] = useState<boolean>(true);
  // const [showCardMask2, setShowCardMask2] = useState<boolean>(true);
  // const { xs } = useBreakpoint();

  const isEnglish = isLocaleEnglish(i18n.language);
  const { data: bankList, shouldFetch: shouldFetchBankList } = useBankCode(token || '');
  const {
    shouldFetch: shouldFecthDrop,
    data: dropData,
    // isLoading: dropDataisLoading,
  } = useRequestDropDown('useRequestDropDown', token || '');
  const { shouldFetch, data: downUrl } = useGetOptionAndPaymentPdf('useGetOptionAndPaymentPdf', token || '');
  const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  useEffect(() => {
    shouldFecthDrop(true);
    shouldFetch(true);
  }, [shouldFecthDrop, shouldFetch]);
  const dropDatanew = dropData?.filter((item) =>
    form.getFieldValue('correspondencePolicyNo')?.includes(item.policyNumber),
  );
  dropDatanew?.map((item) => {
    policyTypesObject.push({
      label: i18n.language == 'en' ? item.productName : item.productNameTC,
      label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
      value: item.policyNumber,
    });
  });
  useEffect(() => {
    shouldFetchBankList(true);
  }, [shouldFetchBankList]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const myBankList: { label: string; value: string }[] = [];
  bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
    myBankList.push({
      label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
      value: item.bankCode,
    });
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // useEffect(() => {
  //   const a = myBankList?.find((item) => item.value === form.getFieldValue('bankCode'))?.label;
  //   if (a) {
  //     setbankdefult(a);
  //   } else {
  //     setbankdefult(form.getFieldValue('bankCode'));
  //   }
  //   // eslint-disable-line react-hooks/exhaustive-deps
  // }, [myBankList, form]);
  const downloadPdf = () => {
    if (isEnglish) {
      if (downUrl?.optionDownloadServiceFormEn) {
        const link = document.createElement('a');
        const url = downUrl.optionDownloadServiceFormEn;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    } else {
      if (downUrl?.optionDownloadServiceFormTc) {
        const link = document.createElement('a');
        const url = downUrl.optionDownloadServiceFormTc;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    }
  };
  // const changeToTc = (value: string) => {
  //   switch (value) {
  //     // case 'Cash Payment':
  //     //   return i18n.language == 'en' ? value : '支取現金';
  //     // case 'Accumulate with interest':
  //     //   return i18n.language == 'en' ? value : '積存生息';
  //     // case 'Paid Up Additions':
  //     //   return i18n.language == 'en' ? value : '購買繳費保險';

  //     // case 'Credit to Policyholder’s local bank account in Hong Kong currency':
  //     //   return i18n.language == 'en' ? value : '轉帳至保單持有人本地銀行之港幣戶囗';
  //     // case 'Cheque':
  //     //   return i18n.language == 'en' ? value : '現金';
  //     case 'USD':
  //       return i18n.language == 'en' ? value : '美金';
  //     case 'HKD':
  //       return i18n.language == 'en' ? value : '港幣';
  //     default:
  //       return '-';
  //   }
  // };
  const findoptionlabel = (code: string, propslist: commonListProps[], key = '') => {
    if (!code) return '-';
    if (code == 'TT') return key == 'D' ? props.divPMName : props.payPMName;
    const list = propslist.find((i) => i.code == code);
    if (!list) {
      if (key == 'divi') {
        return props.diviName;
      }
      if (key == 'pay') {
        return props.payName;
      }
    }
    return i18n.language == 'en' ? list?.label : list?.labelTc;
  };
  const findbankLabel = (code: string) => {
    if (!code) return '';
    const obj = myBankList.find((i) => i.value == code);
    return obj?.label;
  };

  return (
    <div>
      <Row justify="center" className="policynoeditRow" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
        {props.dividendOptionsList.length > 0 && (
          <div>
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                    {t('life.policyOptions.dividendOptions')}
                  </span>
                }
                name="dividendOptions"
              >
                <div
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #CCCCCC',
                    // color: "white",
                    backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    marginBottom: '10px',
                    padding: '4px 0',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  {findoptionlabel(form.getFieldValue('dividendOptionsCode'), props.dividendOptionsList, 'divi')}
                  {form.getFieldValue('dividendOptionsFlag') === 'Y' && (
                    <div
                      style={{
                        background: '#E9573D',
                        borderRadius: '20px',
                        padding: '4px 8px',
                        fontSize: '15px',
                        fontFamily: 'Roboto700',
                        color: '#FFF',
                        height: '31.5px',
                        minWidth: '91px',
                        textAlign: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {t('life.MakeRequest.contact.UnderReview')}
                    </div>
                  )}
                </div>
              </BoldLabelFormItem>
            </Col>
            {form.getFieldValue('dividendOptionsCode') == 'CASHPAYS' && (
              <Col xs={24} md={24}>
                <BoldLabelFormItem
                  label={
                    <span
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        paddingLeft: '20px',
                      }}
                    >
                      {t('life.policyOptions.dividendOptionsCashPaymentMethod')}
                    </span>
                  }
                  name="dividendOptionsCashPaymentMethod"
                >
                  <div
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #CCCCCC',
                      // color: "white",
                      backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 0',
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingLeft: '20px',
                    }}
                  >
                    {findoptionlabel(
                      form.getFieldValue('dividendOptionsCashPaymentMethodCode'),
                      props.paymentMethodList,
                      'D',
                    )}
                    {form.getFieldValue('dividendOptionsCashPaymentMethodFlag') === 'Y' && (
                      <div
                        style={{
                          background: '#E9573D',
                          borderRadius: '20px',
                          padding: '4px 8px',
                          fontSize: '15px',
                          fontFamily: 'Roboto700',
                          color: '#FFF',
                          height: '31.5px',
                          minWidth: '91px',
                          flexShrink: 0,
                          textAlign: 'center',
                        }}
                      >
                        {t('life.MakeRequest.contact.UnderReview')}
                      </div>
                    )}
                  </div>
                </BoldLabelFormItem>
              </Col>
            )}
            {form.getFieldValue('dividendOptionsCashPaymentMethodCode') == 'CQ' && (
              <Col xs={24} md={24}>
                <BoldLabelFormItem
                  label={
                    <span
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        paddingLeft: '20px',
                      }}
                    >
                      {t('life.policyOptions.dividendOptionsCashPaymentMethodCheque')}
                    </span>
                  }
                  name="dividendOptionsCashPaymentMethodCheque"
                >
                  <div
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #CCCCCC',
                      // color: "white",
                      backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 0',
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingLeft: '20px',
                    }}
                  >
                    {findoptionlabel(form.getFieldValue('dividendOptionsCashPaymentMethodCheque'), props.chequeList)}
                    {form.getFieldValue('dividendOptionsChequeFlag') === 'Y' && (
                      <div
                        style={{
                          background: '#E9573D',
                          borderRadius: '20px',
                          padding: '4px 8px',
                          fontSize: '15px',
                          fontFamily: 'Roboto700',
                          color: '#FFF',
                          height: '31.5px',
                          minWidth: '91px',
                          flexShrink: 0,
                          textAlign: 'center',
                        }}
                      >
                        {t('life.MakeRequest.contact.UnderReview')}
                      </div>
                    )}
                  </div>
                </BoldLabelFormItem>
              </Col>
            )}
            {form.getFieldValue('dividendOptionsCashPaymentMethodCode') == 'DC' && (
              <div>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.dividendOptionsCashPaymentMethodBankCode')}
                      </span>
                    }
                    name="dividendOptionsCashPaymentMethodBankCode"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      {findbankLabel(form.getFieldValue('dividendOptionsCashPaymentMethodBankCode')) ?? '-'}
                      {form.getFieldValue('dividendOptionsCashPaymentMethodBankCodeFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.dividendOptionsCashPaymentMethodBranchNo')}
                      </span>
                    }
                    name="dividendOptionsCashPaymentMethodBranchNo"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div> {form.getFieldValue('dividendOptionsCashPaymentMethodBranchNo') ?? '-'}</div>
                      {form.getFieldValue('dividendOptionsCashPaymentMethodBranchNoFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.dividendOptionsCashPaymentMethodAccountNo')}
                      </span>
                    }
                    name="dividendOptionsCashPaymentMethodAccountNo"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      {/* <div
                        className="bankAccountNumber"
                        style={{
                          width:
                            form.getFieldValue('dividendOptionsCashPaymentMethodAccountNoFlag') === 'Y'
                              ? xs
                                ? '65%'
                                : '75%'
                              : '100%',
                        }}
                      > */}
                      {/* {showCardMask
                          ? formatCardNumber2(form.getFieldValue('dividendOptionsCashPaymentMethodAccountNo'))
                          :  */}
                      {form.getFieldValue('dividendOptionsCashPaymentMethodAccountNo')}
                      {/* </div> */}
                      {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}> */}
                      {/* {showCardMask ? (
                          <img
                            style={{
                              marginRight:
                                form.getFieldValue('dividendOptionsCashPaymentMethodAccountNoFlag') === 'Y'
                                  ? '10px'
                                  : '0',
                            }}
                            src={Visibility}
                            onClick={() => setShowCardMask(!showCardMask)}
                          />
                        ) : (
                          <img
                            style={{
                              marginRight:
                                form.getFieldValue('dividendOptionsCashPaymentMethodAccountNoFlag') === 'Y'
                                  ? '10px'
                                  : '0',
                            }}
                            src={VisibilityOff}
                            onClick={() => setShowCardMask(!showCardMask)}
                          />
                        )} */}
                      {form.getFieldValue('dividendOptionsCashPaymentMethodAccountNoFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.dividendOptionsCashPaymentMethodHolderName')}
                      </span>
                    }
                    name="dividendOptionsCashPaymentMethodHolderName"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      {form.getFieldValue('dividendOptionsCashPaymentMethodHolderName') ?? '-'}
                      {form.getFieldValue('dividendOptionsCashPaymentMethodHolderNameFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                    </div>
                  </BoldLabelFormItem>
                </Col>
              </div>
            )}
          </div>
        )}
        {props.paymentOptionsList.length > 0 && (
          <div>
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                    {t('life.policyOptions.paymentOptions')}
                  </span>
                }
                name="paymentOptions"
              >
                <div
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #CCCCCC',
                    // color: "white",
                    backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    marginBottom: '10px',
                    padding: '4px 0',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  {findoptionlabel(form.getFieldValue('paymentOptionsCode'), props.paymentOptionsList, 'pay')}
                  {form.getFieldValue('paymentOptionsFlag') === 'Y' && (
                    <div
                      style={{
                        background: '#E9573D',
                        borderRadius: '20px',
                        padding: '4px 8px',
                        fontSize: '15px',
                        fontFamily: 'Roboto700',
                        color: '#FFF',
                        height: '31.5px',
                        minWidth: '91px',
                        textAlign: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {t('life.MakeRequest.contact.UnderReview')}
                    </div>
                  )}
                </div>
              </BoldLabelFormItem>
            </Col>
            {form.getFieldValue('paymentOptionsCode') == 'CASHPAYS' && (
              <Col xs={24} md={24}>
                <BoldLabelFormItem
                  label={
                    <span
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        paddingLeft: '20px',
                      }}
                    >
                      {t('life.policyOptions.paymentOptionsCashPaymentMethod')}
                    </span>
                  }
                  name="paymentOptionsCashPaymentMethod"
                >
                  <div
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #CCCCCC',
                      // color: "white",
                      backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 0',
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingLeft: '20px',
                    }}
                  >
                    {findoptionlabel(
                      form.getFieldValue('paymentOptionsCashPaymentMethodCode'),
                      props.annPaymentMethodList,
                      'P',
                    )}

                    {form.getFieldValue('paymentOptionsCashPaymentMethodFlag') === 'Y' && (
                      <div
                        style={{
                          background: '#E9573D',
                          borderRadius: '20px',
                          padding: '4px 8px',
                          fontSize: '15px',
                          fontFamily: 'Roboto700',
                          color: '#FFF',
                          height: '31.5px',
                          minWidth: '91px',
                          textAlign: 'center',
                          flexShrink: 0,
                        }}
                      >
                        {t('life.MakeRequest.contact.UnderReview')}
                      </div>
                    )}
                  </div>
                </BoldLabelFormItem>
              </Col>
            )}
            {form.getFieldValue('paymentOptionsCashPaymentMethodCode') == 'CQ' && (
              <Col xs={24} md={24}>
                <BoldLabelFormItem
                  label={
                    <span
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto500',
                        paddingLeft: '20px',
                      }}
                    >
                      {t('life.policyOptions.paymentOptionsCashPaymentMethodCheque')}
                    </span>
                  }
                  name="paymentOptionsCashPaymentMethodCheque"
                >
                  <div
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #CCCCCC',
                      // color: "white",
                      backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 0',
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingLeft: '20px',
                    }}
                  >
                    {findoptionlabel(form.getFieldValue('paymentOptionsCashPaymentMethodCheque'), props.chequeList)}
                    {form.getFieldValue('paymentOptionsChequeFlag') === 'Y' && (
                      <div
                        style={{
                          background: '#E9573D',
                          borderRadius: '20px',
                          padding: '4px 8px',
                          fontSize: '15px',
                          fontFamily: 'Roboto700',
                          color: '#FFF',
                          height: '31.5px',
                          minWidth: '91px',
                          textAlign: 'center',
                          flexShrink: 0,
                        }}
                      >
                        {t('life.MakeRequest.contact.UnderReview')}
                      </div>
                    )}
                  </div>
                </BoldLabelFormItem>
              </Col>
            )}
            {form.getFieldValue('paymentOptionsCashPaymentMethodCode') == 'DC' && (
              <div>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.paymentOptionsCashPaymentMethodBankCode')}
                      </span>
                    }
                    name="paymentOptionsCashPaymentMethodBankCode"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div> {findbankLabel(form.getFieldValue('paymentOptionsCashPaymentMethodBankCode')) ?? '-'}</div>
                      {form.getFieldValue('paymentOptionsCashPaymentMethodBankCodeFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.paymentOptionsCashPaymentMethodBranchNo')}
                      </span>
                    }
                    name="paymentOptionsCashPaymentMethodBranchNo"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div> {form.getFieldValue('paymentOptionsCashPaymentMethodBranchNo') ?? '-'}</div>
                      {form.getFieldValue('paymentOptionsCashPaymentMethodBranchNoFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.paymentOptionsCashPaymentMethodAccountNo')}
                      </span>
                    }
                    name="paymentOptionsCashPaymentMethodAccountNo"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      {/* <div
                        className="bankAccountNumber"
                        style={{
                          width:
                            form.getFieldValue('paymentOptionsCashPaymentMethodAccountNoFlag') === 'Y'
                              ? xs
                                ? '65%'
                                : '75%'
                              : '100%',
                        }}
                      > */}
                      {/* {showCardMask2
                          ? formatCardNumber2(form.getFieldValue('paymentOptionsCashPaymentMethodAccountNo'))
                          :  */}
                      {form.getFieldValue('paymentOptionsCashPaymentMethodAccountNo')}
                      {/* </div> */}
                      {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}> */}
                      {/* {showCardMask2 ? (
                          <img
                            style={{
                              marginRight:
                                form.getFieldValue('paymentOptionsCashPaymentMethodAccountNoFlag') === 'Y'
                                  ? '10px'
                                  : '0',
                            }}
                            src={Visibility}
                            onClick={() => setShowCardMask2(!showCardMask2)}
                          />
                        ) : (
                          <img
                            style={{
                              marginRight:
                                form.getFieldValue('paymentOptionsCashPaymentMethodAccountNoFlag') === 'Y'
                                  ? '10px'
                                  : '0',
                            }}
                            src={VisibilityOff}
                            onClick={() => setShowCardMask2(!showCardMask2)}
                          />
                        )} */}
                      {form.getFieldValue('paymentOptionsCashPaymentMethodAccountNoFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.paymentOptionsCashPaymentMethodHolderName')}
                      </span>
                    }
                    name="paymentOptionsCashPaymentMethodHolderName"
                  >
                    <div
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div> {form.getFieldValue('paymentOptionsCashPaymentMethodHolderName') ?? '-'}</div>
                      {form.getFieldValue('paymentOptionsCashPaymentMethodHolderNameFlag') === 'Y' && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            height: '31.5px',
                            minWidth: '91px',
                            textAlign: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {t('life.MakeRequest.contact.UnderReview')}
                        </div>
                      )}
                    </div>
                  </BoldLabelFormItem>
                </Col>
              </div>
            )}
          </div>
        )}
      </Row>

      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
        <Col xs={24} md={24}>
          <div
            style={{
              border: 'none',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '17px',
              fontFamily: 'Roboto400',
              color: '#6F7072',
            }}
          >
            {t('life.MakeRequest.contact.FooterText')}
          </div>
        </Col>
        <Col xs={24} md={24}>
          <div
            style={{
              border: 'none',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '17px',
              fontFamily: 'Roboto500',
              color: '#C21B17',
              textAlign: 'center',
              marginTop: '24px',
            }}
          >
            <span onClick={downloadPdf} style={{ cursor: 'pointer' }}>
              {t('life.MakeRequest.contact.FooterButton')}
              <img src={redright} style={{ margin: '0  2px 0 10px', width: '8px', height: '14px' }} />
            </span>
          </div>
        </Col>
      </Row>
    </div>
  );
};
